import { DesignLevel } from '@/lib/enums';

export const ContextType = Object.freeze({
  ACTIVITY: 'ACTIVITY',
  ACTIVITY_ADD: 'ACTIVITY_ADD',
  BULK_SELECTION: 'BULK_SELECTION',
  COMPARE: 'COMPARE',
  COPY_AS_SCENARIO: 'COPY_AS_SCENARIO',
  DIAGRAM_DIFF: 'DIAGRAM_DIFF',
  DESIGN_ACTIVITY: 'DESIGN_ACTIVITY',
  DESIGN_GROUP: 'DESIGN_GROUP',
  DESIGN_ROLE: 'DESIGN_ROLE',
  EXPORT: 'EXPORT',
  FILTERS: 'FILTERS',
  LENS: 'LENS',
  GROUP: 'GROUP',
  GROUP_ADD: 'GROUP_ADD',
  GROUP_ADD_BULK: 'GROUP_ADD_BULK',
  GROUP_ARCHIVE: 'GROUP_ARCHIVE',
  GROUP_PRIORITIZE: 'GROUP_PRIORITIZE',
  GROUP_SUPPORTERS: 'GROUP_SUPPORTERS',
  GROUP_REBASE: 'GROUP_REBASE',
  ORGANISATION: 'ORGANISATION',
  HISTORY: 'HISTORY',
  INSIGHTS: 'INSIGHTS',
  IMPORT: 'IMPORT',
  LIBRARY_ACTIVITIES: 'LIBRARY_ACTIVITIES',
  LIBRARY_ACTIVITY: 'LIBRARY_ACTIVITY',
  LIBRARY_PERSON: 'LIBRARY_PERSON',
  LIBRARY_PROCESS_L1: 'LIBRARY_PROCESS_L1',
  LIBRARY_PROCESS_L2: 'LIBRARY_PROCESS_L2',
  LIBRARY_PROCESS_L2_ACTIVITY_ADD: 'LIBRARY_PROCESS_L2_ACTIVITY_ADD',
  LIBRARY_PROPERTY: 'LIBRARY_PROPERTY',
  LIBRARY_PROPERTY_OPTION: 'LIBRARY_PROPERTY_OPTION',
  LIBRARY_ROLE: 'LIBRARY_ROLE',
  LIBRARY_ROLE_ADD: 'LIBRARY_ROLE_ADD',
  LIBRARY_ROLES: 'LIBRARY_ROLES',
  LIBRARY_SKILL: 'LIBRARY_SKILL',
  LIBRARY_TAG: 'LIBRARY_TAG',
  LIBRARY_TAG_CATEGORY: 'LIBRARY_TAG_CATEGORY',
  LIBRARY_TAG_SOURCE: 'LIBRARY_TAG_SOURCE',
  MANAGER: 'MANAGER',
  PERSON: 'PERSON',
  PROPERTIES: 'PROPERTIES',
  PULSE: 'PULSE',
  ROLE: 'ROLE',
  ROLE_ADD: 'ROLE_ADD',
  ROLE_ARCHIVE: 'ROLE_ARCHIVE',
  ROLE_COPY: 'ROLE_COPY',
  ROLE_INVITE: 'ROLE_INVITE',
  ROLE_MOVE: 'ROLE_MOVE',
  ROLE_CHANGE_PARENT: 'ROLE_CHANGE_PARENT',
  ROLE_OVERVIEW: 'ROLE_OVERVIEW',
  ROLE_PRIORITIZE: 'ROLE_PRIORITIZE',
  ROLE_PUBLISH: 'ROLE_PUBLISH',
  ROLE_REBALANCE_BULK: 'ROLE_REBALANCE_BULK',
  ROLE_SAVE_TO_LIBRARY: 'ROLE_SAVE_TO_LIBRARY',
  ROLE_UPDATE_FROM_LIBRARY: 'ROLE_UPDATE_FROM_LIBRARY',
  SCENARIO_DETAILS: 'SCENARIO_DETAILS',
  SETTINGS: 'SETTINGS',
  SHARE: 'SHARE',
  SKILL_PEOPLE: 'SKILL_PEOPLE',
  TAGS: 'TAGS',
  UNALLOCATED: 'UNALLOCATED',
});

export const DesignLayout = Object.freeze({
  DIAGRAM: 'DIAGRAM',
  LIST: 'LIST',
});

export const AllowedLayouts = Object.freeze({
  [DesignLevel.GROUP]: new Set([DesignLayout.DIAGRAM]),
  [DesignLevel.MANAGER]: new Set([DesignLayout.DIAGRAM]),
  [DesignLevel.ORGANISATION]: new Set([DesignLayout.DIAGRAM]),
  [DesignLevel.PERSON]: new Set([DesignLayout.DIAGRAM]),
  [DesignLevel.ROLE]: new Set([DesignLayout.DIAGRAM, DesignLayout.LIST]),
  [DesignLevel.LIBRARY_ROLES]: new Set([DesignLayout.DIAGRAM]),
});

export const ExportableImageTypes = Object.freeze({
  PNG: 'PNG',
  SVG: 'SVG',

  /**
   * @param {String} [value]
   * @returns {String|undefined}
   */
  maxSize(value) {
    const maxSize = {
      [this.PNG]: 8000,
      [this.SVG]: null,
    };
    return maxSize[value?.toUpperCase()];
  },
});
